// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__1eVzm","searchIcon":"SearchBar_searchIcon__1rzCt","input":"SearchBar_input__2gnPF","form":"SearchBar_form__3DWIc"};